import InputMask, { ReactInputMask } from 'react-input-mask';

function PhoneNumberMask(props: Readonly<ReactInputMask>) {
  return <InputMask mask="(99) 99999-9999" {...props} />;
}

export default PhoneNumberMask;
